import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Textarea = styled.textarea`
  background: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.S};
  color: ${Colors.black};
  font-family: 'Roboto', sans-serif;
  font-feature-settings: 'case' on;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.03125rem;
  line-height: 140%;
  min-height: 5rem;
  padding: ${Spacing.Xs};
  resize: none;

  &::placeholder {
    color: ${Colors.gray[100]};
  }
`;
